// extracted by mini-css-extract-plugin
export default {"container":"tab_container__-ouNo","tabItem":"tab_tabItem__diejY","active":"tab_active__Gh6us"};